import React from "react";
import { SourceTypeEnum } from "../../../api/models/source-type-enum";
import { useSourceListItem } from "./SourceListItemHook";
import { openFileExcel } from "../../../utils/helpers/OpenDocumentHelper";
import { SourceListItem } from "../../interfaces/SourceListItemObj";
import { getHTMLElementAsButtonProps } from "../../../common/accessibility/HTMLElementAsButtonARIA";

export interface SourceListItemProps {
  source: string;
  obj: SourceListItem;
}

const RenderIcon = (props: SourceListItemProps & { iconClassNames: string }) => {
  if (SourceTypeEnum.TAGETIK === props.source)
    return <img src={"/assets/db-1x.png"} alt={"Database Icon"} className={props.iconClassNames} />;
  else return <img src={"/assets/excel-1x.png"} alt={"Excel Icon"} className={props.iconClassNames} />;
};

export const SourceListItemView: React.FunctionComponent<SourceListItemProps> = (props) => {
  const { classNames } = useSourceListItem();

  return (
    <div className={classNames.item}>
      <RenderIcon {...props} iconClassNames={classNames.icon} />
      {SourceTypeEnum.TAGETIK === props.source ? (
        <div className={classNames.fontName}>{props.obj.desc}</div>
      ) : (
        <div
          className={classNames.attachment}
          {...getHTMLElementAsButtonProps({
            onClick: () => {
              openFileExcel(props.obj.cod);
            },
          })}
        >
          {props.obj.desc}
        </div>
      )}
    </div>
  );
};
